import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';

export default function PowerHomes() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.PowerHomes');

    return (
        <div className={`${styles.PowerHomes}`}>
            <div className="text-box">
                <div className="sub-title">{t('label')}</div>
                <h2 className="product-title">{t('title')}</h2>
                <div className="desc">{t('desc')}</div>
            </div>

            <div className="img-box">
                <div className="scroller-box">
                    <div className="left-img">
                        <EcoImg
                            className="img-pc"
                            pc="https://websiteoss.ecoflow.com/upload/image/1765764380918/card1-pc.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1765764341613/card1-h5.jpg"
                        />
                        <div className="text-img">
                            <div className="left-title">{t('item_title1')}</div>
                            <div className="left-desc">{t('item_desc1')}</div>
                        </div>
                    </div>

                    <div className="right-img">
                        <div className="top-img">
                            <EcoImg
                                className="img-pc"
                                pc="https://websiteoss.ecoflow.com/upload/image/1765764381129/card2-pc.jpg"
                                pad="https://websiteoss.ecoflow.com/upload/image/1765764341753/card2-h5.jpg"
                            />

                            <div className="text-img">
                                <div className="left-title">{t('item_title2')}</div>
                                <div className="left-desc">{t('item_desc2')}</div>
                            </div>
                        </div>

                        <div className="bottom-img">
                            <EcoImg
                                className="img-pc"
                                pc="https://websiteoss.ecoflow.com/upload/image/1765764381345/card3-pc.jpg"
                                pad="https://websiteoss.ecoflow.com/upload/image/1765764341933/card3-h5.jpg"
                            />

                            <div className="text-img">
                                <div className="left-title">{t('item_title3')}</div>
                                <div className="left-desc">{t('item_desc3')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
